import { render, staticRenderFns } from "./TransferInfo.vue?vue&type=template&id=0c83bfac&"
import script from "./TransferInfo.vue?vue&type=script&lang=js&"
export * from "./TransferInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports